import { Injectable } from '@angular/core';
import { AbstractNavigationService } from './abstract-navigation.service';
import { NavigableRecord, BaseNavigationQueryParams } from './navigable-record.interface';

@Injectable({ providedIn: 'root' })
export class CompanyNavigationService extends AbstractNavigationService<NavigableRecord, BaseNavigationQueryParams> {
  protected override readonly basePath = ['master', 'configuration', 'company'];
  protected override readonly navigationDescription = 'Ver en Compañías';
}
